// /einstellungen ohne Unterseite: führt auf die Seite zum alten Anker (/einstellungen#close → Close-Schlüssel),
// sonst auf „Konto“. So funktionieren alle bisherigen Links (Fehlermeldungen, Telefon, E-Mail-Hinweis) weiter.
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { sichtbareSeiten, seiteFuerAnker, STANDARD_SEITE } from "./seiten";

export default function EinstellungenStart() {
  const { nutzer } = useAuth();
  const { hash } = useLocation();
  const anker = hash.replace(/^#/, "");
  const ziel = anker ? seiteFuerAnker(anker, sichtbareSeiten(nutzer?.permissions ?? [])) : undefined;
  return <Navigate to={`/einstellungen/${ziel?.pfad ?? STANDARD_SEITE}${ziel ? `#${anker}` : ""}`} replace />;
}
